const UPDATE_MODEL_EVENT = "update:modelValue";
const CHANGE_EVENT = "change";
const INPUT_EVENT = "input";

export { CHANGE_EVENT, INPUT_EVENT, UPDATE_MODEL_EVENT };
//# sourceMappingURL=constants.mjs.map
